'use client';
'use strict';

var jsxRuntime = require('react/jsx-runtime');
var generatedCraftcms = require('@liquorice/generated-craftcms');
var material = require('@mui/material');
var reactHookForm = require('react-hook-form');
var createFieldControl = require('../lib/form/createFieldControl.js');
var useFieldOptions = require('../lib/parse/useFieldOptions.js');
var FieldErrors = require('./FieldErrors/FieldErrors.js');

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const FIELD_RADIO_FRAGMENT = generatedCraftcms.gql(`
  fragment fieldRadio on Field_Radio {
    __typename
    ...fieldBase
    layout
    options {
      ...fieldOption
    }
  }
`);
const Field_Radio = createFieldControl.createField(FIELD_RADIO_FRAGMENT, (field, { methods })=>{
    const { label, handle, required, options: _options, instructions, layout, labelPosition } = field;
    const { defaultValue, options } = useFieldOptions(_options);
    const { field: fieldControl, fieldState: { error } } = reactHookForm.useController({
        name: handle,
        control: methods.control,
        defaultValue: defaultValue != null ? defaultValue : ''
    });
    return /*#__PURE__*/ jsxRuntime.jsxs(material.FormControl, {
        required: required,
        error: !!error,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx(material.FormLabel, {
                component: "legend",
                sx: {
                    mb: 1
                },
                hidden: labelPosition === 'hidden',
                children: label
            }),
            /*#__PURE__*/ jsxRuntime.jsx(FieldErrors, {
                errors: error
            }),
            /*#__PURE__*/ jsxRuntime.jsx(material.FormHelperText, {
                children: instructions
            }),
            /*#__PURE__*/ jsxRuntime.jsx(material.RadioGroup, _extends({}, fieldControl, {
                row: layout === 'horizontal',
                sx: {
                    mb: 1
                },
                children: options.map((v)=>/*#__PURE__*/ jsxRuntime.jsx(material.FormControlLabel, {
                        value: v.value,
                        control: /*#__PURE__*/ jsxRuntime.jsx(material.Radio, {}),
                        label: v.label
                    }, v.value))
            }))
        ]
    });
});

exports.FIELD_RADIO_FRAGMENT = FIELD_RADIO_FRAGMENT;
exports.Field_Radio = Field_Radio;
